import React from "react";
import Header from "../../components/Header";
import { WebIM } from "components/WebIM";
import style from "./index.module.scss";

const Chat = () => {
    return (
        <div>
            <Header />

            <div className={style.root}>
                <WebIM.FullIM />
            </div>
        </div>
    );
};

export default Chat;
